import React from 'react';
import Form from '../form/form3';

import './app.scss';

const App = () => (
  <div className="App">
    <h2>Форма регистрации</h2>
    <Form />
  </div>
);

export default App;
